<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<p class="dedi"><span class="Italic-Style">To my brother Bob and our late mother Norma Jean, with love.</span> </p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication2.vue?c82637ce